/**
 * Mevcut Kasa stok hesabı (mevcutkasa.js ile aynı mantık).
 */
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  Timestamp,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

const CATEGORIES = [
  {
    key: 'sarrafiye',
    name: 'Sarrafiye',
    items: [
      { key: 'eskiZiynetCeyrek', label: 'Eski Ziynet Çeyrek' },
      { key: 'yeniZiynetCeyrek', label: 'Yeni Ziynet Çeyrek' },
      { key: 'eskiZiynetYarim', label: 'Eski Ziynet Yarım' },
      { key: 'yeniZiynetYarim', label: 'Yeni Ziynet Yarım' },
      { key: 'eskiZiynetTam', label: 'Eski Ziynet Tam' },
      { key: 'yeniZiynetTam', label: 'Yeni Ziynet Tam' },
      { key: 'eskiZiynetGremse', label: "Eski Ziynet 2.5'lu Gremse" },
      { key: 'yeniZiynetGremse', label: "Yeni Ziynet 2.5'lu Gremse" },
      { key: 'eskiZiynetBesli', label: 'Eski Ziynet Beşli' },
      { key: 'yeniZiynetBesli', label: 'Yeni Ziynet Beşli' },
      { key: 'cumhuriyetAtaCeyrek', label: 'Cumhuriyet Ata Çeyrek' },
      { key: 'cumhuriyetAtaYarim', label: 'Cumhuriyet Ata Yarım' },
      { key: 'cumhuriyetAta', label: 'Cumhuriyet Ata' },
      { key: 'cumhuriyetAtaGremse', label: "Cumhuriyet Ata 2.5'lu Gremse" },
      { key: 'cumhuriyetAtaBesli', label: 'Cumhuriyet Ata Beşli' },
      { key: 'resatCeyrek', label: 'Reşat Çeyrek' },
      { key: 'resatYarim', label: 'Reşat Yarım' },
      { key: 'resat', label: 'Reşat' },
      { key: 'resatGremse', label: "Reşat 2.5'lu Gremse" },
      { key: 'resatBesli', label: 'Reşat Beşli' },
    ],
  },
  {
    key: 'gramAltin',
    name: 'Gram Altın',
    items: [
      { key: 'birGram22Ayar', label: '1 Gram 22 Ayar' },
      { key: 'yariGram22Ayar', label: '0.50 Gram 22 Ayar' },
      { key: 'ceyrekGram22Ayar', label: '0.25 Gram 22 Ayar' },
      { key: 'birGram24Ayar', label: '1 Gram 24 Ayar' },
      { key: 'yariGram24Ayar', label: '0.50 Gram 24 Ayar' },
      { key: 'ceyrekGram24Ayar', label: '0.25 Gram 24 Ayar' },
      { key: 'ikiBucukGram24Ayar', label: '2.50 Gram 24 Ayar' },
      { key: 'besGram24Ayar', label: '5 Gram 24 Ayar' },
      { key: 'onGram24Ayar', label: '10 Gram 24 Ayar' },
      { key: 'yirmiGram24Ayar', label: '20 Gram 24 Ayar' },
      { key: 'elliGram24Ayar', label: '50 Gram 24 Ayar' },
      { key: 'yuzGram24Ayar', label: '100 Gram 24 Ayar' },
    ],
  },
  {
    key: 'hurda',
    name: 'Hurda',
    items: [
      { key: 'yirmiDortAyarHurda', label: '24 Ayar Hurda' },
      { key: 'yirmiIkiAyarBilezikHurda', label: '22 Ayar Bilezik Hurda' },
      { key: 'yirmiIkiAyarHurda', label: '22 Ayar Hurda' },
      { key: 'yirmiBirAyarHurda', label: '21 Ayar Hurda' },
      { key: 'onSekizAyarHurda', label: '18 Ayar Hurda' },
      { key: 'onDortAyarHurda', label: '14 Ayar Hurda' },
      { key: 'sekizAyarHurda', label: '8 Ayar Hurda' },
    ],
  },
  {
    key: 'doviz',
    name: 'Döviz',
    items: [
      { key: 'tl', label: 'TL - Türk Lirası' },
      { key: 'usd', label: 'USD - Amerikan Doları' },
      { key: 'eur', label: 'EUR - Euro' },
      { key: 'gbp', label: 'GBP - İngiliz Sterlini' },
      { key: 'chf', label: 'CHF - İsviçre Frangı' },
      { key: 'aud', label: 'AUD - Avustralya Doları' },
      { key: 'cad', label: 'CAD - Kanada Doları' },
      { key: 'sar', label: 'SAR - Suudi Arabistan Riyali' },
      { key: 'aed', label: 'AED - Birleşik Arap Emirlikleri Dirhemi' },
      { key: 'qar', label: 'QAR - Katar Riyali' },
      { key: 'mad', label: 'MAD - Fas Dirhemi' },
      { key: 'jod', label: 'JOD - Ürdün Dinarı' },
      { key: 'kwd', label: 'KWD - Kuveyt Dinarı' },
      { key: 'cny', label: 'CNY - Çin Yuanı' },
      { key: 'rub', label: 'RUB - Rus Rublesi' },
      { key: 'bgn', label: 'BGN - Bulgar Levası' },
    ],
  },
];

function normalizeString(str) {
  return str ? str.trim().toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ') : '';
}

function emptyKasa() {
  const kasa = {};
  CATEGORIES.forEach((category) => {
    kasa[category.key] = {};
    category.items.forEach((item) => {
      kasa[category.key][item.key] = { adet: 0, gram: 0 };
    });
  });
  return kasa;
}

/**
 * @returns {Promise<{ kasaData: object, bankaBakiyesi: number, nakitKasa: number }>}
 */
export async function fetchMevcutKasa(sube) {
  if (!sube) throw new Error('Şube gerekli');

  const bankaQuery = query(
    collection(db, 'subeler', sube, 'islemler'),
    where('havaleEft', '>', 0)
  );
  const bankaSnapshot = await getDocs(bankaQuery);
  let bankaBakiyesi = 0;
  bankaSnapshot.docs.forEach((docSnap) => {
    const data = docSnap.data();
    const miktar = parseFloat(data.havaleEft) || 0;
    if (['Satış', 'Giriş'].includes(data.islemTuru)) bankaBakiyesi += miktar;
    else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(data.islemTuru)) bankaBakiyesi -= miktar;
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const gunsonuQuery = query(
    collection(db, 'subeler', sube, 'gunsonukasa'),
    where('timestamp', '<', Timestamp.fromDate(today)),
    orderBy('timestamp', 'desc'),
    limit(1)
  );
  const gunsonuSnapshot = await getDocs(gunsonuQuery);
  const dunkuKapanis = !gunsonuSnapshot.empty ? gunsonuSnapshot.docs[0].data() : {};
  const lastGunsonuTimestamp = dunkuKapanis.timestamp || new Timestamp(0, 0);

  const islemQuery = query(
    collection(db, 'subeler', sube, 'islemler'),
    where('timestamp', '>=', lastGunsonuTimestamp),
    orderBy('timestamp', 'asc')
  );
  const querySnapshot = await getDocs(islemQuery);
  const islemler = querySnapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

  const kasa = emptyKasa();
  CATEGORIES.forEach((category) => {
    if (!dunkuKapanis[category.key]) return;
    category.items.forEach((item) => {
      const dunkuAdet = dunkuKapanis[category.key]?.[item.key]?.adet || 0;
      const dunkuGram = dunkuKapanis[category.key]?.[item.key]?.gram || 0;
      kasa[category.key][item.key] = { adet: Number(dunkuAdet), gram: Number(dunkuGram) };
    });
  });

  islemler.forEach((islem) => {
    const islemUrun = normalizeString(islem.urun);
    const islemKategori = normalizeString(islem.kategori);
    const gramMiktar = parseFloat(islem.gram) || 0;
    const adetMiktar = parseInt(islem.adet, 10) || 0;
    const nakitMiktar = parseFloat(islem.nakit) || 0;
    const isTL = islem.kategori === 'Döviz' && islem.urun === 'TL - Türk Lirası';

    if (nakitMiktar > 0) {
      if (['Satış', 'Çıkış'].includes(islem.islemTuru)) {
        if (isTL) kasa.doviz.tl.adet -= nakitMiktar;
        else kasa.doviz.tl.adet += nakitMiktar;
      } else if (['Alış', 'İade', 'Değişim', 'Giriş'].includes(islem.islemTuru)) {
        if (isTL) kasa.doviz.tl.adet += nakitMiktar;
        else kasa.doviz.tl.adet -= nakitMiktar;
      }
    }

    const stokEtkilenmeli = !(
      islem.teslimatDurumu === 'Teslimat Bekliyor' &&
      ['Satış', 'Çıkış'].includes(islem.islemTuru)
    );
    if (!stokEtkilenmeli) return;

    CATEGORIES.forEach((category) => {
      if (islemKategori !== normalizeString(category.name)) return;
      category.items.forEach((item) => {
        if (normalizeString(item.label) !== islemUrun) return;
        if (item.key === 'tl') return;

        const inbound = ['Alış', 'İade', 'Değişim', 'Giriş'].includes(islem.islemTuru);
        const outbound = ['Satış', 'Çıkış'].includes(islem.islemTuru);
        if (!inbound && !outbound) return;

        const sign = inbound ? 1 : -1;
        if (category.key === 'sarrafiye' || category.key === 'gramAltin' || category.key === 'doviz') {
          kasa[category.key][item.key].adet += sign * adetMiktar;
        } else if (category.key === 'hurda') {
          kasa[category.key][item.key].gram += sign * gramMiktar;
        }

        if (category.key === 'hurda') {
          kasa[category.key][item.key].gram = Number(kasa[category.key][item.key].gram.toFixed(2));
        }
        if (category.key === 'doviz') {
          kasa[category.key][item.key].adet = Number(kasa[category.key][item.key].adet.toFixed(2));
        }
      });
    });
  });

  return {
    kasaData: kasa,
    bankaBakiyesi,
    nakitKasa: kasa.doviz?.tl?.adet || 0,
  };
}
